<template>
  <v-card class="elevation-12">
    <v-toolbar color="primary" dark>
      {{ $t('unitsPage2.pageTitle') }}
    </v-toolbar>
    <v-data-table
        :items="units"
        :server-items-length="total"
        :headers="headers"
        :options.sync="options"
        :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100, 200] }"
    >
      <template v-slot:item.createdOn="{item}">
        {{ item.createdOn.format('DD.MM.YYYY HH:mm:ss')}}
      </template>


      <template v-slot:top>
        <v-sheet color="grey lighten-3"
                 class="px-4 pt-4 pb-3"
                 tile>
          <h3 class="transition-swing font-weight-medium">{{ $t('unitsPage2.filterTitle') }}</h3>
          <v-responsive>
            <v-row>
              <v-col cols="12" sm="6" md="3" lg="3" class="">
                <v-autocomplete v-model="filters.inn"
                                :items="organizations"
                                :label="$t('common.labels.organization')"
                                :dense="true"
                                :clearable="true"
                                item-text="name"
                                item-value="inn"/>
              </v-col>
              <v-spacer/>
              <v-col cols="12" sm="12" md="12" class="py-2 d-flex justify-space-between">
                <v-btn color="primary" @click="load">
                  {{ $t('common.actions.update') }}
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <v-btn color="primary" @click="onAddUnitButtonClicked">{{ $t('unitsPage2.addBtn') }}</v-btn>
                <v-dialog v-model="addUnitDialog" :persistent="true" width="600px">
                  <AddUnitComponent
                      :organizations="organizations"
                      :allowed-regions="allowedRegions"
                      @cancel="onAddUnitCanceled"
                      @added="onAddUnitSuccess"/>
                </v-dialog>
              </v-col>
            </v-row>
          </v-responsive>
        </v-sheet>
      </template>

      <template v-slot:item.name="{item}">
        <template v-if="item.isAdmin">
          <v-badge
              color="error"
              :content="$t('userTypes.admin')"
          >
            {{ item.name }}
          </v-badge>
        </template>
        <template v-else>
          {{ item.name }}
        </template>
      </template>

      <template v-slot:item.actions="{item}">
        <v-btn icon @click="onEditUnitButtonClicked(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="editUnitDialog" :persistent="true" width="600px">
      <EditUnitComponent ref="editUnit"
                         :allowed-regions="allowedRegions"
                         @cancel="onEditUnitCanceled"
                         @updated="onEditUnitSuccess" />
    </v-dialog>

    <v-snackbar v-model="isAddUnitSuccess"
                :timeout="5000"
                :top="true"
                color="success"
    >
      {{ $t('unitsPage2.messages.addSuccess') }}
    </v-snackbar>

    <v-snackbar v-model="isEditUnitSuccess"
                :timeout="5000"
                :top="true"
                color="success"
    >
      {{ $t('unitsPage2.messages.editSuccess') }}
    </v-snackbar>
  </v-card>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import UnitService from "@/services/unit.service";
import _ from "underscore";
import Mappers from "@/mappers";
import OrganizationService from "@/services/organization.service";
import AddUnitComponent from "../../components/unit/AddUnitComponent";
import EditUnitComponent from "../../components/unit/EditUnitComponent";
import Vue from "vue";
import {API_HOST} from "@/settings/server";
import Mapper from "../../mappers";

export default {
  name: "unitsPage",
  components: {
    AddUnitComponent,
    EditUnitComponent
  },
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 50,
      },

      units: [],
      organizations: [],
      total: 0,

      filters: {
        inn: null
      },

      allowedRegions: [],

      addUnitDialog: false,
      editUnitDialog: false,
      isAddUnitSuccess: false,
      isEditUnitSuccess: false
    }
  },
  computed: {
    headers() {
      const headers = []

      headers.push({
        text: this.$t('tableHeaders3.number'),
        align: 'center',
        sortable: false,
        value: 'displayNumber'
      })

      headers.push({
        text: this.$t('tableHeaders3.name'),
        align: 'left',
        sortable: true,
        value: 'name'
      })

      headers.push({
        text: this.$t('common.labels.organization'),
        align: 'left',
        sortable: true,
        value: 'organization.name'
      })

      headers.push({
        text: this.$t('tableHeaders3.tin'),
        align: 'center',
        sortable: true,
        value: 'organization.inn'
      })

      headers.push({
        text: this.$t('tableHeaders3.address'),
        align: 'left',
        sortable: true,
        value: 'address'
      })

      headers.push({
        text: this.$t('tableHeaders2.departmentRegistrationDate'),
        align: 'center',
        sortable: true,
        value: 'createdOn'
      })

      headers.push({
        text: '',
        align: 'right',
        sortable: false,
        value: 'actions'
      })

      return headers
    },
    items() {
      let number = 1;
      let skip = this.skip;
      return _.map(this.users, u => {
        u.displayNumber = skip + (number++)
        return u
      })

    },
    skip() {
      return (this.options.page - 1) * this.options.itemsPerPage
    }
  },
  methods: {
    load() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      const {page, itemsPerPage} = this.options;
      const skip = (page - 1) * itemsPerPage;


      UnitService.getUnits({inn: this.filters.inn, skip: skip, limit: itemsPerPage })
          .then(response => {
            let displayNumber = 0
            this.units = _.map(response.data.Records, u => {
              let unit = Mappers.mapUnit(u)
              unit.displayNumber = ++displayNumber

              return unit
            })
            this.total = response.data.Total
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadOrganizations() {
      this.$store.dispatch(LAYOUT_LOADING_START)

      OrganizationService.getOrganizations({})
          .then(response => {
            this.organizations = _.map(response.data.Records, o => {
              return Mappers.mapOrganization(o?.Organization)
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadAllowedRegions() {
      let vm = this;
      Vue.axios.get(`${API_HOST}/api/UnitRegion`, {
        headers: {
          'Authorization': `Bearer ${this.$store.getters.accessToken}`
        }
      }).then(response => {
        vm.allowedRegions = _.map(response.data, regionViewModel => {
          return Mapper.mapRegion(regionViewModel)
        })

      }).catch((error) => console.log(error))
    },
    onAddUnitButtonClicked() {
      this.addUnitDialog = true
    },
    onAddUnitCanceled() {
      this.addUnitDialog = false
    },
    onAddUnitSuccess() {
      this.isAddUnitSuccess = true
      this.addUnitDialog = false
      this.load()
    },
    onEditUnitButtonClicked(unit) {
      this.editUnitDialog = true

      this.$nextTick(() => {
        this.$refs.editUnit.set(unit)
      })
    },
    onEditUnitCanceled() {
      this.editUnitDialog = false
    },
    onEditUnitSuccess() {
      this.isEditUnitSuccess = true
      this.editUnitDialog = false
      this.load()
    }
  },
  mounted() {
    this.loadAllowedRegions()
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('unitsPage2.pageTitle'))

    this.loadOrganizations()
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.load()
      }
    },
    options: {
      deep: true,
      handler() {
        this.load()
      }
    }
  }
}
</script>

<style scoped>

</style>